import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 6v12","key":"svg-0"}],["path",{"d":"M18 6l-6 6l6 6","key":"svg-1"}]]

const IconChevronLeftPipe = createReactComponent('outline', 'chevron-left-pipe', 'ChevronLeftPipe', __iconNode);

export default IconChevronLeftPipe;